import React from 'react';

import { ReactComponent as CloseIcon } from '../../../../assets/svg/close-icon.svg';

import { GMapModalAC } from '../../../../stores/reducers/gMapModal/AC';

import { useDispatch } from 'react-redux';

import styles from './CloseModal.module.scss';

const CloseModal = () => {
  const dispatch = useDispatch();
  return (
      <button
        className={styles.closeButton}
        onClick={() => dispatch(GMapModalAC.hideModal())}
      >
        <CloseIcon />
      </button>
  );
};

export default CloseModal;
